import { FormErrors } from 'redux-form';
import { calculateAge, rutValidator } from '../helpers/utils';
import { IQuoteForm } from '../store/Quote';

const regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9-]+\.[A-Z]{2,4}$/i;
const regexDate = /^((0?[1-9]|[12][0-9]|3[01])[- /.](0?[1-9]|1[012])[- /.](19|20)?[0-9]{2})*$/i;
const regexPhone = /^(9|2)?[0-9]{8}$/i;

export default (values: IQuoteForm) => {
  const errors: FormErrors<IQuoteForm> = {};

  if (!values.fullName) {
    errors.fullName = 'Campo obligatorio';
  }

  if (!values.documentId) {
    errors.documentId = 'Campo obligatorio';
  } else if (!rutValidator(values.documentId)) {
    errors.documentId = 'Rut inválido';
  }

  if (!values.birthdate) {
    errors.birthdate = 'Campo obligatorio';
  } else if (!regexDate.test(values.birthdate)) {
    errors.birthdate =
      'Formato de fecha inválido, el formato es dd-mm-aaaa y el año no debe ser menor de 1900';
  } else if (
    Math.trunc(calculateAge(values.birthdate).years) < 18 ||
    Math.trunc(calculateAge(values.birthdate).years) > 65
  ) {
    errors.birthdate = 'El asegurado debe tener entre 18 y 64 años y 364 días';
  }

  if (!values.mail) {
    errors.mail = 'Campo obligatorio';
  } else if (!regexEmail.test(values.mail)) {
    errors.mail = 'Correo inválido';
  }

  if (!values.phone) {
    errors.phone = 'Campo obligatorio';
  } else if (values.phone.trim().length < 9) {
    errors.phone = 'Teléfono inválido, debe contener 9 digitos';
  } else if (!regexPhone.test(values.phone.trim())) {
    errors.phone = 'El teléfono debe empezar por 9 o 2';
  }

  if (!values.genre) {
    errors.genre = 'Campo obligatorio';
  }

  if (!values.region) {
    errors.region = 'Campo obligatorio';
  }

  if (!values.province) {
    errors.province = 'Campo obligatorio';
  }

  if (!values.commune) {
    errors.commune = 'Campo obligatorio';
  }

  if (!values.address) {
    errors.address = 'Campo obligatorio';
  }

  if (!values.addressNumber) {
    errors.addressNumber = 'Campo obligatorio';
  }

  return errors;
};
